import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// Admin Settings configs owned by startup-backend (/admin-configs/:type):
// profile_completion (profile score weights) and utm_campaign_list (campaign -> Brevo template).
const base = () => `${process.env.REACT_APP_STARTUP_BASE_URL}/admin-configs`;
const headers = () => ({ 'Authorization': `Bearer ${checkForAuthorization()}`, 'Content-type': 'application/json' });
const queryOptions = {
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => RetryOnError(failureCount, error),
    onError: (err) => verifyToken(err),
};
const mutationOptions = { retry: 0, onError: (err) => verifyToken(err) };

export const FetchAdminConfig = (type) => useQuery(
    ['admin-config', type],
    () => axios({ method: 'get', url: `${base()}/${type}`, headers: headers() }),
    { ...queryOptions, select: (data) => data?.data?.data },
);

export const UpdateAdminConfig = (type) => useMutation(
    (payload) => axios({ method: 'put', url: `${base()}/${type}`, headers: headers(), data: payload }),
    mutationOptions,
);

export const FetchAdminConfigRevisions = (type, { enabled = true } = {}) => useQuery(
    ['admin-config-revisions', type],
    () => axios({ method: 'get', url: `${base()}/${type}/revisions`, headers: headers() }),
    { ...queryOptions, enabled, select: (data) => data?.data?.data || [] },
);

export const RestoreAdminConfigRevision = (type) => useMutation(
    ({ _id }) => axios({ method: 'post', url: `${base()}/${type}/revisions/${_id}/restore`, headers: headers() }),
    mutationOptions,
);

// What saving these weights would do to every startup's score, without saving.
export const PreviewProfileWeights = () => useMutation(
    (weights) => axios({ method: 'post', url: `${base()}/profile_completion/preview`, headers: headers(), data: { weights } }),
    mutationOptions,
);
